"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Observer2 = require("./Observer");

var _Observer3 = _interopRequireDefault(_Observer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmailModel = function (_Observer) {
    _inherits(EmailModel, _Observer);

    /**
     * War die Änderung der Email erfolgreich? 
     * @type {boolean}
    */


    /**
     * Hat die Email eine gültige Syntax?
     * @type {boolean}
     */
    function EmailModel(observers, id, request) {
        _classCallCheck(this, EmailModel);

        var _this = _possibleConstructorReturn(this, (EmailModel.__proto__ || Object.getPrototypeOf(EmailModel)).call(this, observers, id, request));

        _this.ChangeSuccess = false;

        _this.ValidSyntax = false;
        _this.AccountExists = false;
        return _this;
    }

    /**
     * Existiert bereits ein Account mit der EmailAdresse
     * @type {boolean}
     */


    _createClass(EmailModel, [{
        key: "ChangeMail",
        value: function ChangeMail(email) {
            var me = this;
            this.request.setRequest("/AccountsChangeMail");
            this.request.setData(JSON.stringify({ MailNew: email }));
            this.request.setType("POST");
            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        me.ChangeSuccess = result.Data;
                    }
                }
                var id = me.Id ? me.Id : "AccountsChangeMail";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: "ActivateChangeEmail",
        value: function ActivateChangeEmail() {
            var me = this;
            this.request.setRequest("/AccountsChangeMail");
            this.request.setType("DELETE");
            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        me.ChangeSuccess = result.Data;
                    }
                }
                var id = me.Id ? me.Id : "ActivateChangeMail";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: "CheckMail",
        value: function CheckMail(email) {
            var me = this;
            this.request.setRequest("/CheckMailAddresses");
            this.request.setData({ mailAddress: email });
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        if (result.Data.ValidSyntax !== null && result.Data.ValidSyntax !== undefined) {
                            me.ValidSyntax = result.Data.ValidSyntax;
                        }
                        if (result.Data.AccountExists !== null && result.Data.AccountExists !== undefined) {
                            me.AccountExists = result.Data.AccountExists;
                        }
                    }
                }
                var id = me.Id ? me.Id : "CheckMail";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }]);

    return EmailModel;
}(_Observer3.default);

exports.default = EmailModel;